// @ts-nocheck
import * as React from "react";

const ClockFill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m15.646 16.354.708-.708-3.854-3.854V7h-1v5.208l4.146 4.146ZM12.003 21a8.773 8.773 0 0 1-3.51-.709 9.095 9.095 0 0 1-2.859-1.922 9.081 9.081 0 0 1-1.925-2.857A8.752 8.752 0 0 1 3 12.003c0-1.244.236-2.414.708-3.51a9.096 9.096 0 0 1 1.923-2.859 9.081 9.081 0 0 1 2.857-1.925A8.752 8.752 0 0 1 11.997 3c1.244 0 2.414.236 3.51.708a9.096 9.096 0 0 1 2.859 1.923 9.082 9.082 0 0 1 1.925 2.857A8.752 8.752 0 0 1 21 11.997a8.772 8.772 0 0 1-.709 3.51 9.095 9.095 0 0 1-1.922 2.859 9.082 9.082 0 0 1-2.857 1.925 8.752 8.752 0 0 1-3.509.709ZM12 20c2.217 0 4.104-.78 5.663-2.337C19.22 16.104 20 14.217 20 12s-.78-4.104-2.337-5.662C16.104 4.779 14.217 4 12 4s-4.104.78-5.662 2.338C4.779 7.896 4 9.783 4 12s.78 4.104 2.338 5.663C7.896 19.22 9.783 20 12 20Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(ClockFill);
